import * as _ from 'lodash';
import Guid from '~/helpers/guid';
import UntrackedModel from '../untracked/untrackedModel';

export default class ExternalConnectionEnvironmentAPIHeaderPair extends UntrackedModel {
  key: string;
  value: string;
  secure: boolean;

  except = ['id', 'createEmbeddedObject', 'saveTimer', 'rootModel'];

  constructor(collectionName = 'header_pairs') {
    super();
    this._nameInParent = collectionName;
    this.client_id = Guid.create();
    this.secure = false;
  }
  
  environmentCredentials() {
    return _.pick(this, ['key', 'value']);
  }

}
